import { useEffect, useState } from 'react';
import { getDocs, query, where, collection, orderBy, limit } from "firebase/firestore";
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import { dbaccounting } from '../firebase';
import { MdBusiness, MdOutlineNumbers, MdOutlinePrivacyTip, MdSettings } from 'react-icons/md';
import Statusbar from '../body_root/statusbar';
export default function New_website_settings() {
    const navigate = useNavigate();
    const servicetablename = "accountingfinancedb";
    const [activeTab, setActiveTab] = useState("settings");
    const [islogin, setislogin] = useState(true);
    const [userlogin, setuserlogin] = useState(false);
    const [companystatus, setcompanystatus] = useState(false);

    const [guid, setGuid] = useState("");

    const [companydata, setcompanydata] = useState([]);


    return (
        <div>
            <Statusbar data={"New Website"} /> 
            <div className="container_roots">

                
            </div>
        </div>
    );

}


